import React from 'react';
import { Tabs } from 'antd';
import { ADAPTATION_CATEGORIES } from '../../constants';

interface AdaptationTabsProps {
  activeTab: string;
  onChange: (key: string) => void;
  children: React.ReactNode;
}

const AdaptationTabs: React.FC<AdaptationTabsProps> = ({
  activeTab,
  onChange,
  children,
}) => {
  const tabItems = [
    {
      key: 'all',
      label: 'All Adaptations',
    },
    ...Object.values(ADAPTATION_CATEGORIES).map(category => ({
      key: category,
      label: category,
    }))
  ];

  return (
    <Tabs
      activeKey={activeTab}
      onChange={onChange}
      type="card"
      items={tabItems.map(item => ({
        ...item,
        children: children,
      }))}
    />
  );
};

export default AdaptationTabs; 